// extracted by mini-css-extract-plugin
module.exports = {"InputGroup":"InputGroup_InputGroup__10pb4","InputGroup__label":"InputGroup_InputGroup__label__2RO98","InputGroup__input-guide":"InputGroup_InputGroup__input-guide__12dVf"};